import script from "./ReserveSuccessModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReserveSuccessModal.vue?vue&type=script&setup=true&lang=js"

import "./ReserveSuccessModal.vue?vue&type=style&index=0&id=b17da43c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b17da43c"]])

export default __exports__